'use client'

import CreationToolCutOutMode from 'creation/src/creation-tools/types/cut-out-mode'
import { useCutOut } from '../cut-out-context'
import Lasso from './lasso'
import Magic from './magic'
import Pen from './pen'

type Props = {
    scale: number
}

const Tools = ({ scale }: Props) => {
    const { mode } = useCutOut()

    switch (mode) {
        case CreationToolCutOutMode.Lasso:
            return <Lasso scale={scale} />
        case CreationToolCutOutMode.Erase:
        case CreationToolCutOutMode.Paint:
            return <Pen scale={scale} />
        case CreationToolCutOutMode.MagicWand:
            return <Magic />
        default:
            return null
    }
}

export default Tools
